export class Report {
  static ReportTypes = {
    csvReportType: { id: 0, name: 'CSV' },
    usedValueReportType: { id: 1, name: 'Used Value' },
    idReportType: { id: 3, name: 'ID' },
    futureValuesReportType: { id: 4, name: 'Future Value' },
    unsoldVehiclesReportType: { id: 6, name: 'Unsold Vehicles' },
    disposalReportType: { id: 8, name: 'Disposal' },
    movementReportType: { id: 10, name: 'Movement' },
    mileageReportType: { id: 12, name: 'Mileage' }
  };

  static SummaryPdfSupportedReports = [
    Report.ReportTypes.usedValueReportType,
    Report.ReportTypes.futureValuesReportType,
    Report.ReportTypes.unsoldVehiclesReportType,
    Report.ReportTypes.disposalReportType,
    Report.ReportTypes.movementReportType,
    Report.ReportTypes.mileageReportType
  ];

  id: number;
  title: string;
  description: string;
  generationDate: Date;
  filename: string;
  isDeleted = false;
  isRenaming = false;
  isSelected = false;
  reportTypeId;
  reportStatusId;
}



// WEBPACK FOOTER //
// ./src/app/report/models/report.model.ts